// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".default-input[data-v-258847c5]{height:5.867vw}.default-input[data-v-258847c5]::-webkit-input-placeholder{color:#c7c7d7!important;font-size:3.2vw!important;font-family:PingFang HK!important;font-style:normal!important;font-weight:400!important}.is-label[data-v-258847c5]{text-align:right}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
